<h2 mat-dialog-title>Add or Modify Rule</h2>

<mat-dialog-content style="width: 410px; height: 241px; padding: 20px;">

  <div style="flex-direction: column; box-sizing: border-box; display: flex;">
    <mat-form-field appearance="fill" style="width:100%;">
      <mat-label>Select preset or custom</mat-label>
      <mat-select [(ngModel)]="autoRedactionRule.presetType" (selectionChange)="setPreset($event)" style="width:100%;">
        <mat-option *ngFor="let preset of presets.all" [value]="preset.type">{{preset.displayValue}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="autoRedactionRule.presetType === PresetType.customPlainText">
      <textarea matInput required maxlength="4000" (input)="validateRule()" [(ngModel)]="autoRedactionRule.rulePattern" placeholder="Rule Text" rows="1"></textarea>
    </mat-form-field>
    <mat-form-field *ngIf="autoRedactionRule.presetType === PresetType.customRegex">
      <textarea matInput required maxlength="4000" (input)="validateRule()" [(ngModel)]="autoRedactionRule.rulePattern" placeholder="Rule Text using OpenSearch syntax" rows="1"></textarea>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Rule Title</mat-label>
      <input matInput maxlength="100" [(ngModel)]="autoRedactionRule.ruleTitle" />
    </mat-form-field>
    <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch space-between; align-items: stretch; gap: 3%;">
      <mat-form-field>
        <mat-label>Redaction Text</mat-label>
        <input matInput maxlength="100" [(ngModel)]="autoRedactionRule.redactionLabel" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Redaction Color</mat-label>
        <mat-select [(ngModel)]="autoRedactionRule.redactionColorId">
          <mat-option *ngFor="let color of redactionColors" [value]="color.id">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: row; place-content: stretch space-between; align-items: stretch;">
              <div>{{color.name}}</div>
              <div [style.background-color]="color.value" style="height: 15px;width: 90px;margin-left: 25px;"></div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-error *ngIf="hasDuplicateRule" style="align-self: end">Rule already added</mat-error>
  </div>

</mat-dialog-content>

<mat-dialog-actions style="box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: stretch;">
  <div>
    <mat-error style="max-width: 350px;">{{validationMessage}}</mat-error>
  </div>
  <div style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
    <button mat-raised-button color="primary" (click)="ok()"
            [disabled]="!autoRedactionRule.rulePattern || autoRedactionRule.rulePattern.length < 1 || !autoRedactionRule.ruleTitle || autoRedactionRule.ruleTitle.length < 1 || hasDuplicateRule">Ok
    </button>
    <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
  </div>
</mat-dialog-actions>
